<template>
  <div id="app">
    <div :class="{ hideIt: !seen }">
    <div class="text-header p-1">
      <h3 class="text-white py-4 text-center" v-html="textes.title">
        
      </h3>
    </div>
    <div class="container py-2 mt-2" >
      <p class="p" v-html="textes.paragraph1">
       
      </p>
      <p class="p" v-html="textes.paragraph2">
        
      </p>
    </div>
    </div>

    <div class="container d-flex justify-content-center">
      <div class="form-container">
        <div class="title text-center">
          <h1 id="formtitleh" class="p-0 m-0" v-html="textes.titreForm"></h1>
        </div>
        <div class="row align-items-center bt-0 pb-0">
          <div class="col-md-12 mx-auto">
            <!-- progress -->
            <div class="progress mt-4">
              <div
                class="progress-bar"
                role="progressbar"
                aria-valuenow="0"
                aria-valuemin="0"
                aria-valuemax="100"
                :style="`width: ${progress}%;`"
              ></div>
            </div>
            <!-- end progress -->
            <div :class="(!show) ? 'fade' : ''">
              <div class="row" v-if="step == 1">
                <div class="col-md-6 offset-md-3">
                  <div class="row">
                    <div class="col-md-12 title_form_section mt-3 mb-3">
                      Etes-vous propriétaire d'un logement ?
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.isOwner === 'true') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="isOwnertrue"
                          v-model="data.keys.isOwner"
                          @click="next()"
                          name="isOwner"
                          type="radio"
                          value="true"
                        />
                        <label for="isOwnertrue">Oui</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.isOwner === 'false') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="isOwnerfalse"
                          v-model="data.keys.isOwner"
                          @click="next()"
                          name="isOwner"
                          type="radio"
                          value="false"
                        />
                        <label for="isOwnerfalse">Non</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" v-if="step == 2">
                <div class="col-md-6 offset-md-3">
                  <div class="row">
                    <div class="col-md-12 title_form_section mt-3 mb-3">
                      Avez-vous au moins 1 crédit immobilier ?
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.mortgageLoanNumber === '1') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="mortgageLoanNumbertrue"
                          v-model="data.keys.mortgageLoanNumber"
                          @click="next()"
                          name="mortgageLoanNumber"
                          type="radio"
                          value="1"
                        />
                        <label for="mortgageLoanNumbertrue">Oui</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.mortgageLoanNumber === '0') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="mortgageLoanNumberfalse"
                          v-model="data.keys.mortgageLoanNumber"
                          @click="next()"
                          name="mortgageLoanNumber"
                          type="radio"
                          value="0"
                        />
                        <label for="mortgageLoanNumberfalse">Non</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" v-if="step == 3">
                <div class="col-md-12">
                  <div class="row">
                    <div
                      class="col-md-12 title_form_section mt-3 mb-3"
                      style="font-size: 12pt"
                    >
                      Combien reste-t-il à rembourser sur vos crédits
                      immobiliers ?
                        <div v-if="threenexterror != ''" class="alert alert-danger mt-1">
                        {{threenexterror}}
                    </div>
                    </div>
                   
                    <div class="col-md-12">
                      <div class="row">
                        <div class="col-md-6 offset-md-3">
                          <select
                            class="custom-select custom-select-lg mb-3"
                            :class="[[(sectionone)?'is-valid':''],[(sectionone_1)?'is-invalid':'']]"
                            v-model="data.keys.realEstateCapital"
                            @change="realEstateCapitalchange"
                            name="realEstateCapital"
                          >
                            <option value="250000">Plus de 250 000 €</option>
                            <option value="225000"> De 200 000 à 250 000 €</option>
                            <option value="175000"> De 150 000€ à 200 000 €</option>
                            <option value="125000"> De 100 000€ à 150 000 €</option>
                            <option value="75000">De 50 000 à 100 000 €</option>
                            <option value="50000">Moins de 50 000 €</option>
                            <option
                              @click="sectionone = true"
                              value="0"
                              selected
                            >
                              0€
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="row">
                    <div
                      class="col-md-12 title_form_section mt-3 mb-3"
                      style="font-size: 12pt"
                    >
                      Mensualités cumulées de vos différents crédits immobiliers
                    </div>
                    <div class="col-md-12">
                      <div class="row">
                        <div class="col-md-6 offset-md-3">
                          <select
                            class="custom-select custom-select-lg mb-3"
                            :class="[[(sectiontwo)?'is-valid':''],[(sectiontwo_2)?'is-invalid':'']]"
                            v-model="data.keys.monthlyRealEstate"
                            @change="monthlyRealEstatechange"
                            name="monthlyRealEstate"
                          >
                           <option value="1500">Plus de 1 500€ / Mois</option>
                            <option value="1300"> De 1 200€ à 1 500€ / Mois</option>
                            <option value="1100">De 900€ à 1 200€ / Mois</option>
                            <option value="800">De 700€ à 900€ / Mois</option>
                            <option value="600">De 500€ à 700€ / Mois</option>
                            <option value="400">De 200€ à 500€ / Mois</option>
                            <option value="200">Moins de 200€ / Mois</option>  
                            <option @click="sectiontwo = true" value="0">
                              0€
                            </option>                           
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="d-flex justify-content-center">
                    <button
                      class="btn btn-success text-white mt-2"
                      @click="threenext()"
                    >
                      Je Continue
                    </button>
                  </div>
                </div>
              </div>
              <div class="row"  v-if="step == 4 && consumptionCreditNumbertoggle">
                <div class="col-md-12">
                  <div class="row d-flex justify-content-center">
                    <div class="col-md-12 text-center mt-3 mb-2">
                      <div
                        class="title_form_section mt-3 mb-2"
                        style="font-size: 12pt"
                      >
                        Combien avez-vous de crédits à la consommation ?
                      </div>
                      <h6 style="font-size: 0.9rem">
                        Crédit auto, crédit renouvelable, crédit travaux ,
                        paiements en plusieurs fois etc…
                      </h6>
                      <div class="alert alert-danger" v-if="confirm_credit_status">
                        Attention, au moins 1 crédit conso est nécessaire pour
                        être éligible au regroupement de crédit
                    </div>
                    </div>
                    <!--
                    <div class="mt-4" v-if="togglealert">
                      <div class="d-flex justify-content-center">
                  
                    </div>
                  </div>
                -->
                  <div
                    class="d-flex justify-content-center"
                    v-if="!togglealert"
                  >
                  
                    <label
                      for="consumptionCreditNumber0"
                      :class="[(data.keys.consumptionCreditNumber == '0') ? 'btn btn-active btn-lg active m-2' : 'btn btn-primary btn-lg active m-2']"
                    >
                      <input
                        type="radio"
                        class="btn-input"
                        name="consumptionCreditNumber"
                        @click="next()"
                        v-model="data.keys.consumptionCreditNumber"
                        id="consumptionCreditNumber0"
                        value="0"
                      />
                      0
                    </label>
                    <label
                      for="consumptionCreditNumber1"
                      :class="[(data.keys.consumptionCreditNumber == '1') ? 'btn btn-active btn-lg active m-2' : 'btn btn-primary btn-lg active m-2']"
                    >
                      <input
                        type="radio"
                        class="btn-input"
                        name="consumptionCreditNumber"
                        @click="next()"
                        v-model="data.keys.consumptionCreditNumber"
                        id="consumptionCreditNumber1"
                        value="1"
                      />
                      1
                    </label>
                    <label
                      for="consumptionCreditNumber2"
                      :class="[(data.keys.consumptionCreditNumber == '2') ? 'btn btn-active btn-lg active m-2' : 'btn btn-primary btn-lg active m-2']"
                    >
                      <input
                        type="radio"
                        class="btn-input"
                        name="consumptionCreditNumber"
                        @click="next()"
                        v-model="data.keys.consumptionCreditNumber"
                        id="consumptionCreditNumber2"
                        value="2"
                      />
                      2
                    </label>
                    <label
                      for="consumptionCreditNumber3"
                      :class="[(data.keys.consumptionCreditNumber == '3') ? 'btn btn-active btn-lg active m-2' : 'btn btn-primary btn-lg active m-2']"
                    >
                      <input
                        type="radio"
                        class="btn-input"
                        name="consumptionCreditNumber"
                        @click="next()"
                        v-model="data.keys.consumptionCreditNumber"
                        id="consumptionCreditNumber3"
                        value="3"
                      />
                      +3
                    </label>
                  </div>
                    </div>
                  <div class="text-center mt-4">
                    <button class="btn btn-success text-white" @click="confirm_credit()" v-if="confirm_credit_status">Je confirme n'avoir pas de crédits conso en cours</button>
                 </div>
                </div> 
              </div>
              <div class="row" v-if="step == 5">
                <div class="col-md-12">
                  <div class="row">
                    <div
                      class="col-md-12 text-center title_form_section mt-3 mb-3"
                      style="font-size: 12pt"
                    >
                      Combien reste-t-il à rembourser sur l’ensemble de vos
                      crédits à la consommation ?
                    <div v-if="fivenexterror != ''" class="alert alert-danger mt-1">
                        {{fivenexterror}}
                    </div>
                    </div>
                    <div class="col-md-6 offset-md-3">
                      <select
                        class="custom-select custom-select-lg mb-3"
                        :class="[[(consumptionCapitalone)?'is-valid':''],[(consumptionCapitalone_1)?'is-invalid':'']]"
                        v-model="data.keys.consumptionCapital"
                        name="consumptionCapital"
                        @change="consumptionCapitalchange"
                      >
                        <option value="30000">Plus de 30 000€</option>
                        <option value="25000">De 25 000€ à 30 000€</option>
                        <option value="20000">De 20 000 à 25 000€</option>  
                        <option value="15000">De 15 000€ à 20 000€</option>   
                        <option value="10000">De 10 000€ à 15 000€</option>
                        <option value="5000">De 5 000€ à 10 000€</option>
                        <option value="5000">Moins de 5 000€</option>
                        <option
                          @click="consumptionCapitalone = true"
                          value="0"
                          selected
                        >
                          0 €
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" v-if="step == 5">
                <div class="col-md-12">
                  <div class="row">
                    <div
                      class="col-md-12 text-center title_form_section mt-3 mb-3"
                      style="font-size: 12pt"
                    >
                      Mensualités cumulées de vos différents crédits conso ?
                    </div>
                    <div class="col-md-6 offset-md-3">
                      <select
                        class="custom-select custom-select-lg mb-3"
                        v-model="data.keys.monthlyConsumptionRepaymentAmount"
                        :class="[[(monthlyConsumptionRepaymentAmountchangetwo)?'is-valid':''],[(monthlyConsumptionRepaymentAmountchangetwo_2)?'is-invalid':'']]"
                        name="monthlyConsumptionRepaymentAmount"
                        @change="monthlyConsumptionRepaymentAmountchange"
                      >
                         <option value="1500">Plus de 1 500€ /mois</option>
                         <option value="1300">De 1 200€ à 1 500€ / Mois</option>
                         <option value="1100">De 900€ à 1 200€ / Mois</option>
                         <option value="800">De 700€ à 900€ / Mois</option>
                         <option value="600">De 500€ à 700€ / Mois</option>
                         <option value="400">De 200€ à 500€ / Mois</option>
                         <option value="200">Moins de 200€</option>
                         <option
                          @click="monthlyConsumptionRepaymentAmountchangetwo = true "
                          value="0"
                          selected
                        >
                          0 €
                        </option>
                        
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="d-flex justify-content-center">
                    <button
                      class="btn btn-success text-white mt-2"
                      @click="fivenext()"
                    >
                      Je Continue
                    </button>
                  </div>
                </div>
              </div>
              <div class="row" v-if="step == 6">
                <div class="col-md-6 offset-md-3">
                  <div class="row">
                    <div class="col-md-12 mt-3 mb-3 text-center">
                      <div class="title_form_section">
                        Quels sont les revenus de votre ménage ?
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.salary == '800') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="salary800"
                          v-model="data.keys.salary"
                          @click="next()"
                          name="salary"
                          type="radio"
                          value="800"
                        />
                        <label for="salary800">Moins de 800€/Mois</label>
                      </div>
                    </div>
                     <div class="col-md-12">
                      <div
                        :class="[(data.keys.salary == '900') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="salary900"
                          v-model="data.keys.salary"
                          @click="next()"
                          name="salary"
                          type="radio"
                          value="900"
                        />
                        <label for="salary900">De 800€ à 1 000€/mois</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.salary == '1150') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="salary1000"
                          v-model="data.keys.salary"
                          @click="next()"
                          name="salary"
                          type="radio"
                          value="1150"
                        />
                        <label for="salary1000">De 1 000€ à 1 300€/mois</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.salary == '1450') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="salary1800"
                          v-model="data.keys.salary"
                          @click="next()"
                          name="salary"
                          type="radio"
                          value="1450"
                        />
                        <label for="salary1800">De 1 300 à 1 600€/mois</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.salary == '1750') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="salary2200"
                          v-model="data.keys.salary"
                          @click="next()"
                          name="salary"
                          type="radio"
                          value="1750"
                        />
                        <label for="salary2200">De 1 600€ à 1 900€/mois</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.salary == '2000') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="salary2900"
                          v-model="data.keys.salary"
                          @click="next()"
                          name="salary"
                          type="radio"
                          value="2000"
                        />
                        <label for="salary2900">De 1 900€ à 2 200€/mois </label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.salary == '2300') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="salary400"
                          v-model="data.keys.salary"
                          @click="next()"
                          name="salary"
                          type="radio"
                          value="2300"
                        />
                        <label for="salary400">De 2 200€ à 2 500€/mois</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.salary == '2700') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="salary2700"
                          v-model="data.keys.salary"
                          @click="next()"
                          name="salary"
                          type="radio"
                          value="2700"
                        />
                        <label for="salary2700">De 2 500€ à 2 800€/mois</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.salary == '3000') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="salary3000"
                          v-model="data.keys.salary"
                          @click="next()"
                          name="salary"
                          type="radio"
                          value="3000"
                        />
                        <label for="salary3000">De 2 800€ à 3 100€/mois</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.salary == '3300') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="salary3300"
                          v-model="data.keys.salary"
                          @click="next()"
                          name="salary"
                          type="radio"
                          value="3300"
                        />
                        <label for="salary3300">De 3 100 à 3 500€/mois</label>
                      </div>
                    </div>
                     <div class="col-md-12">
                      <div
                        :class="[(data.keys.salary == '3700') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="salary3700"
                          v-model="data.keys.salary"
                          @click="next()"
                          name="salary"
                          type="radio"
                          value="3700"
                        />
                        <label for="salary3700">De  3 500 à 4 000€/mois</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.salary == '4500') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="salary4500"
                          v-model="data.keys.salary"
                          @click="next()"
                          name="salary"
                          type="radio"
                          value="4500"
                        />
                        <label for="salary4500">De  4 000 à 5 000€/mois</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.salary == '5500') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="salary5500"
                          v-model="data.keys.salary"
                          @click="next()"
                          name="salary"
                          type="radio"
                          value="5500"
                        />
                        <label for="salary5500">De  5 000 à 6 000€/mois</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.salary == '6500') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="salary6500"
                          v-model="data.keys.salary"
                          @click="next()"
                          name="salary"
                          type="radio"
                          value="6500"
                        />
                        <label for="salary6500">De  6 000 à 7 000€/mois</label>
                      </div>
                    </div>
                     <div class="col-md-12">
                      <div
                        :class="[(data.keys.salary == '8000') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="salary8000"
                          v-model="data.keys.salary"
                          @click="next()"
                          name="salary"
                          type="radio"
                          value="8000"
                        />
                        <label for="salary8000">De  7 000 à 10 000€/mois</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.salary == '10000') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="salary10000"
                          v-model="data.keys.salary"
                          @click="next()"
                          name="salary"
                          type="radio"
                          value="10000"
                        />
                        <label for="salary10000">Plus de 10 000€/ mois</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" v-if="step == 7">
                <div class="col-md-6 offset-md-3">
                  <div class="row">
                    <div class="col-md-12 mt-3 mb-3 text-center">
                      <div class="title_form_section">
                        Quel est votre statut professionnel ?
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.contract == 'CDI') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="contractCDI"
                          v-model="data.keys.contract"
                          @click="next()"
                          name="contract"
                          type="radio"
                          value="CDI"
                        />
                        <label for="contractCDI">En CDI</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.contract == 'CDD') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="contractCDD"
                          v-model="data.keys.contract"
                          @click="next()"
                          name="contract"
                          type="radio"
                          value="CDD"
                        />
                        <label for="contractCDD">En CDD</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.contract == 'unemployed') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="contractunemployed"
                          v-model="data.keys.contract"
                          @click="next()"
                          name="contract"
                          type="radio"
                          value="unemployed"
                        />
                        <label for="contractunemployed">Sans emploi</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.contract == 'retired') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="contractretired"
                          v-model="data.keys.contract"
                          @click="next()"
                          name="contract"
                          type="radio"
                          value="retired"
                        />
                        <label for="contractretired">Retraité</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.contract == 'seasonal') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="contractseasonal"
                          v-model="data.keys.contract"
                          @click="next()"
                          name="contract"
                          type="radio"
                          value="seasonal"
                        />
                        <label for="contractseasonal">Saisonnier(e)</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.contract == 'public_sector') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="contractpublic_sector"
                          v-model="data.keys.contract"
                          @click="next()"
                          name="contract"
                          type="radio"
                          value="public_sector"
                        />
                        <label for="contractpublic_sector">Fonctionnaire</label>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.contract == 'self_employed_worker') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="contractself_employed_worker"
                          v-model="data.keys.contract"
                          @click="next()"
                          name="contract"
                          type="radio"
                          value="self_employed_worker"
                        />
                        <label for="contractself_employed_worker"
                          >Travailleur indépendant <br />
                          Chef d'entreprise</label
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" v-if="step == 8">
                <div class="col-md-6 offset-md-3">
                  <div class="row">
                    <div class="col-md-12 mt-3 mb-3 text-center">
                      <div class="title_form_section">
                        De quel montant de trésorerie supplémentaire avez-vous besoin ?
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.treasure == '30000') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="treasure0"
                          v-model="data.keys.treasure"
                          @click="next()"
                          name="treasure"
                          type="radio"
                          value="30000"
                        />
                        <label for="treasure0">30 000€</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.treasure == '25000') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="treasure3000"
                          v-model="data.keys.treasure"
                          @click="next()"
                          name="treasure"
                          type="radio"
                          value="25000"
                        />
                        <label for="treasure3000">25 000€</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.treasure == '20000') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="treasure5000"
                          v-model="data.keys.treasure"
                          @click="next()"
                          name="treasure"
                          type="radio"
                          value="20000"
                        />
                        <label for="treasure5000">20 000€</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.treasure == '15000') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="treasure7000"
                          v-model="data.keys.treasure"
                          @click="next()"
                          name="treasure"
                          type="radio"
                          value="15000"
                        />
                        <label for="treasure7000">15 000€</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.treasure == '10000') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="treasure9000"
                          v-model="data.keys.treasure"
                          @click="next()"
                          name="treasure"
                          type="radio"
                          value="10000"
                        />
                        <label for="treasure9000">10 000€</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.treasure == '5000') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="treasure12000"
                          v-model="data.keys.treasure"
                          @click="next()"
                          name="treasure"
                          type="radio"
                          value="5000"
                        />
                        <label for="treasure12000">5 000€</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.treasure == '0') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="treasure12555"
                          v-model="data.keys.treasure"
                          @click="next()"
                          name="treasure"
                          type="radio"
                          value="0"
                        />
                        <label for="treasure12555">0€</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row fade-out" v-if="step == 9">
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-12 mt-3 mb-3 text-center">
                      <div class="title_form_section">
                        Traitement de votre dossier en cours ...
                      </div>
                    </div>
                    <div
                      class="col-md-12 mt-4 mb-3 text-center"
                      v-show="!showbutton"
                    >
                      <div
                        class="spinner-border text-success"
                        role="status"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row fade-out" v-if="step == 10">
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-12 mt-3 mb-3 text-center">
                      <div class="title_form_section">
                        D'après votre profil, vous êtes éligible à un
                        regroupement très attractif, veuillez renseigner vos coordonnées pour recevoir les résultats
                      </div>
                    </div>
                    <div class="offset-md-3 col-md-6">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group">
                            <div class="d-flex ml-4">
                              <label class="mr-4">Civilité :</label>
                              <div class="form-check mr-4">
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  v-model="data.keys.civility"
                                  name="civility"
                                  id="M"
                                  value="M"
                                />
                                <label class="form-check-label" for="M">
                                  M
                                </label>
                              </div>
                              <div class="form-check">
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  v-model="data.keys.civility"
                                  name="civility"
                                  id="F"
                                  value="F"
                                />
                                <label class="form-check-label" for="F">
                                  F
                                </label>
                              </div>
                            </div>
                            <div
                              class="text-danger mt-0"
                              v-if="errors.civility"
                            >
                              {{errors.civility}}
                            </div>
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="form-group">
                            <input
                              :class="[(errors.firstname == '') ? 'form-control input-lg' : 'form-control input-lg is-invalid']"
                              v-model="data.firstName"
                              id="firstname"
                              name="firstname"
                              placeholder="Votre prénom"
                              value=""
                              type="text"
                            />
                            <div
                              class="text-danger mt-0"
                              v-if="errors.firstname"
                            >
                              {{errors.firstname}}
                            </div>
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="form-group">
                            <input
                              :class="[(errors.lastname == '') ? 'form-control input-lg' : 'form-control input-lg is-invalid']"
                              v-model="data.lastName"
                              id="lastname"
                              name="lastname"
                              placeholder="Votre Nom"
                              value=""
                              type="text"
                            />
                            <div
                              class="text-danger mt-0"
                              v-if="errors.lastname"
                            >
                              {{errors.lastname}}
                            </div>
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="form-group">
                            <input
                              :class="[(errors.DOB == '') ? 'form-control input-lg' : 'form-control input-lg is-invalid']"
                              v-model="data.keys.DOB"
                              id="DOB"
                              name="DOB"
                              placeholder="Votre Année de naissance ex:1990"
                              value=""
                              type="tel"
                             onkeypress='return event.charCode >= 48 && event.charCode <= 57'  maxlength="4" pattern="\d{4}"
                            />
                            <div class="text-danger mt-0" v-if="errors.DOB">
                              {{errors.DOB}}
                            </div>
                          </div>
                        </div>

                        <div class="col-md-12">
                          <div class="form-group">
                            <input
                              :class="[(errors.address == '') ? 'form-control input-lg' : 'form-control input-lg is-invalid']"
                              v-model="data.keys.address"
                              id="address"
                              name="address"
                              placeholder="Votre Adresse"
                              value=""
                              type="text"
                            />
                            <div class="text-danger mt-0" v-if="errors.address">
                              {{errors.address}}
                            </div>
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="form-group">
                            <input
                              :class="[(errors.zip == '') ? 'form-control input-lg' : 'form-control input-lg is-invalid']"
                              @input="fetchzipcode"
                              v-model="data.zip"
                              id="zipcode"
                              name="zipcode"
                              placeholder="Votre code postal"
                              value=""
                              onkeypress='return event.charCode >= 48 && event.charCode <= 57'  maxlength="5" pattern="\d{5}"
                              type="tel"
                            />
                            <div class="text-danger mt-0" v-if="errors.zip">
                              {{errors.zip}}
                            </div>
                          </div>
                        </div>
                        <div class="col-md-12" v-if="cities.length > 0">
                          <div class="form-group">
                            <select
                              class="custom-select custom-select-lg"
                              v-model="data.keys.city"
                            >
                              <option
                                selected="selected"
                                value=""
                                disabled="disabled"
                              >
                                Votre ville
                              </option>
                              <option
                                v-for="(city,index) in cities"
                                :key="index"
                                :value="city.name"
                              >
                                {{city.name}}
                              </option>
                            </select>

                            <div class="text-danger mt-0" v-if="errors.city">
                              {{errors.city}}
                            </div>
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="form-group">
                            <input
                              :class="[(errors.email == '') ? 'form-control input-lg' : 'form-control input-lg is-invalid']"
                              v-model="data.email"
                              id="email"
                              name="email"
                              placeholder="Votre Email"
                              value=""
                              type="text"
                            />
                            <div class="text-danger mt-0" v-if="errors.email">
                              {{errors.email}}
                            </div>
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="form-group">
                            <input
                              :class="[(errors.phone == '') ? 'form-control input-lg' : 'form-control input-lg is-invalid']"
                              v-model="data.phone"
                              id="phone"
                              name="phone"
                              placeholder="Votre Téléphone"
                              value=""
                              type="tel"
                              onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                              @keyup="numberWithSpaces"
                              maxlength="14"
                            />
                            <div class="text-danger mt-0" v-if="errors.phone">
                              {{errors.phone}}
                            </div>
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="form-group d-flex justify-content-center">
                            <button
                              class="btn btn-success text-white mt-2"
                              @click="save()"
                            >
                              Recevoir les résultats
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" v-if="step == 11">
                <div class="col-md-12 title_form_section mt-3 mb-3">
                  Encore quelques informations sont nécessaires pour finaliser
                  l’analyse
                </div>
                <div class="col-md-12 title_form_section p-4">
                  <button
                    class="btn btn-success text-white mt-4"
                    @click="next()"
                  >
                    Je Continue
                  </button>
                  <iframe
                    v-if="url != ''"
                    :src="url"
                    width="0"
                    height="0"
                    v-show="false"
                  ></iframe>
                </div>
              </div>

              <div class="row" v-if="step == 12">
                <div class="col-md-6 offset-md-3">
                  <div class="row">
                    <div class="col-md-12 mt-3 mb-3 text-center">
                      <div class="title_form_section">
                        Quelle est votre profession ?
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.profession == 'employee') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="professionemployee"
                          v-model="data.keys.profession"
                          value="employee"
                          @click="next()"
                          name="profession"
                          type="radio"
                        />
                        <label for="professionemployee">Salarié</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.profession == 'retired') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="professionretired"
                          v-model="data.keys.profession"
                          value="retired"
                          @click="next()"
                          name="profession"
                          type="radio"
                        />
                        <label for="professionretired">Retraité</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.profession == 'craftmen') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="professioncraftmen"
                          v-model="data.keys.profession"
                          value="craftmen"
                          @click="next()"
                          name="profession"
                          type="radio"
                        />
                        <label for="professioncraftmen"
                          >Artisan/indépendant</label
                        >
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.profession == 'employee') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="professionemployee"
                          v-model="data.keys.profession"
                          value="employee"
                          @click="next()"
                          name="profession"
                          type="radio"
                        />
                        <label for="professionemployee"
                          >Chef d'entreprise</label
                        >
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.profession == 'liberal_profession') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="professionliberal_profession"
                          v-model="data.keys.profession"
                          value="liberal_profession"
                          @click="next()"
                          name="profession"
                          type="radio"
                        />
                        <label for="professionliberal_profession"
                          >Profession libérale</label
                        >
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.profession == 'student') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="professionstudent"
                          v-model="data.keys.profession"
                          value="student"
                          @click="next()"
                          name="profession"
                          type="radio"
                        />
                        <label for="professionstudent">Etudiant</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.profession == 'unemployed') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="professionunemployed"
                          v-model="data.keys.profession"
                          value="unemployed"
                          @click="next()"
                          name="profession"
                          type="radio"
                        />
                        <label for="professionunemployed"
                          >Sans profession</label
                        >
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.profession == 'unemployed') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="professionunemployed"
                          v-model="data.keys.profession"
                          value="unemployed"
                          @click="next()"
                          name="profession"
                          type="radio"
                        />
                        <label for="professionunemployed"
                          >Recherche d'emploi</label
                        >
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.profession == 'other') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="professionother"
                          v-model="data.keys.profession"
                          value="other"
                          @click="next()"
                          name="profession"
                          type="radio"
                        />
                        <label for="professionother">Autre</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" v-if="step == 13 && data.keys.isOwner == 'true'">
                <div class="col-md-6 offset-md-3">
                  <div class="row">
                    <div class="col-md-12 mt-3 mb-3 text-center">
                      <div class="title_form_section">
                        Quel est la valeur de votre bien immobilier ?
                      </div>
                    </div>
                    <div class="col-md-12 text-center">
                      <input
                        :class="[(errors.realEstateValue == '') ? 'form-control input-lg' : 'form-control input-lg is-invalid']"
                        v-model="data.keys.realEstateValue"
                        @keypress="onlyNumber"
                        placeholder="€"
                      />
                      <p class="text-danger mt-1">{{errors.realEstateValue}}</p>
                      <button
                        class="btn btn-success text-white mt-4"
                        @click="next()"
                      >
                        Valider
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row"  v-if="step == 13 && data.keys.isOwner == 'false'">
                <div class="col-md-6 offset-md-3">
                  <div class="row">
                    <div class="col-md-12 mt-3 mb-3 text-center">
                      <div class="title_form_section">
                        Quel est votre loyer mensuel ?
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.rent == '300') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="rent300"
                          v-model="data.keys.rent"
                          @click="next()"
                          name="rent"
                          type="radio"
                          value="300"
                        />
                        <label for="rent300">300 à 500€</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.rent == '500') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="rent500"
                          v-model="data.keys.rent"
                          @click="next()"
                          name="rent"
                          type="radio"
                          value="500"
                        />
                        <label for="rent500">500 à 700€</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.rent == '700') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="rent700"
                          v-model="data.keys.rent"
                          @click="next()"
                          name="rent"
                          type="radio"
                          value="700"
                        />
                        <label for="rent700">700€ à 900€</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.rent == '900') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="rent900"
                          v-model="data.keys.rent"
                          @click="next()"
                          name="rent"
                          type="radio"
                          value="900"
                        />
                        <label for="rent900">900€ à 1300€</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.rent == '1300') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="rent1300"
                          v-model="data.keys.rent"
                          @click="next()"
                          name="rent"
                          type="radio"
                          value="1300"
                        />
                        <label for="rent1300">Plus de 1300€</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" v-if="step == 14">
                <div class="col-md-6 offset-md-3">
                  <div class="row">
                    <div class="col-md-12 mt-3 mb-3 text-center">
                      <div class="title_form_section">
                        Quelle est votre situation familiale ?
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.familySituation == 'single') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="familySituationsingle"
                          v-model="data.keys.familySituation"
                          @click="next()"
                          name="familySituation"
                          type="radio"
                          value="single"
                        />
                        <label for="familySituationsingle">Célibataire</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.familySituation == 'maried') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="familySituationmaried"
                          v-model="data.keys.familySituation"
                          @click="next()"
                          name="familySituation"
                          type="radio"
                          value="maried"
                        />
                        <label for="familySituationmaried">Marié</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.familySituation == 'pacse') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="familySituationpacse"
                          v-model="data.keys.familySituation"
                          @click="next()"
                          name="familySituation"
                          type="radio"
                          value="pacse"
                        />
                        <label for="familySituationpacse">Pacsé</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.familySituation == 'divorced') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="familySituationdivorced"
                          v-model="data.keys.familySituation"
                          @click="next()"
                          name="familySituation"
                          type="radio"
                          value="divorced"
                        />
                        <label for="familySituationdivorced">Divorcé</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.familySituation == 'widower') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="familySituationwidower"
                          v-model="data.keys.familySituation"
                          @click="next()"
                          name="familySituation"
                          type="radio"
                          value="widower"
                        />
                        <label for="familySituationwidower">Veuf</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" v-if="step == 15">
                <div class="col-md-6 offset-md-3">
                  <div class="row">
                    <div class="col-md-12 mt-3 mb-3 text-center">
                      <div class="title_form_section">
                        Combien avez vous d'enfants à charge ?
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.childNumber == '0') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="childNumber0"
                          v-model="data.keys.childNumber"
                          @click="next()"
                          name="childNumber"
                          type="radio"
                          value="0"
                        />
                        <label for="childNumber0">0</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.childNumber == '1') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="childNumber1"
                          v-model="data.keys.childNumber"
                          @click="next()"
                          name="childNumber"
                          type="radio"
                          value="1"
                        />
                        <label for="childNumber1">1</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.childNumber == '2') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="childNumber2"
                          v-model="data.keys.childNumber"
                          @click="next()"
                          name="childNumber"
                          type="radio"
                          value="2"
                        />
                        <label for="childNumber2">2</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.childNumber == '3') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="childNumber3"
                          v-model="data.keys.childNumber"
                          @click="next()"
                          name="childNumber"
                          type="radio"
                          value="3"
                        />
                        <label for="childNumber3">3</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.childNumber == '4') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="childNumber4"
                          v-model="data.keys.childNumber"
                          @click="next()"
                          name="childNumber"
                          type="radio"
                          value="4"
                        />
                        <label for="childNumber4">4</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.childNumber == '5') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="childNumber5"
                          v-model="data.keys.childNumber"
                          @click="next()"
                          name="childNumber"
                          type="radio"
                          value="5"
                        />
                        <label for="childNumber5">5+</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" v-if="step == 16">
                <div class="col-md-6 offset-md-3">
                  <div class="row">
                    <div class="col-md-12 mt-3 mb-3 text-center">
                      <div class="title_form_section">
                        Êtes-vous fiché(e) à la Banque de France ?
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class='[(data.keys.bankOfFrance == true) ? "inputGroup radioSelected" : "inputGroup"]'
                      >
                        <input
                          id="bankOfFrancetrue"
                          v-model="data.keys.bankOfFrance"
                          @click="next()"
                          type="radio"
                          :value="true"
                        />
                        <label for="bankOfFrancetrue">Oui</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class='[(data.keys.bankOfFrance == false) ? "inputGroup radioSelected" : "inputGroup"]'
                      >
                        <input
                          id="bankOfFrancefalse"
                          v-model="data.keys.bankOfFrance"
                          @click="next()"
                          type="radio"
                          :value="false"
                        />
                        <label for="bankOfFrancefalse">Non</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" v-if="step == 17">
                <div class="col-md-6 offset-md-3">
                  <div class="row">
                    <div class="col-md-12 mt-3 mb-3 text-center">
                      <div class="title_form_section">Avez-vous un co-emprunteur?</div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class='[(data.keys.coBorrower == true) ? "inputGroup radioSelected" : "inputGroup"]'
                      >
                        <input
                          id="coBorrowertrue"
                          v-model="data.keys.coBorrower"
                          @click="next()"
                          type="radio"
                          :value="true"
                        />
                        <label for="coBorrowertrue">Oui</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class='[(data.keys.coBorrower == false) ? "inputGroup" : "inputGroup"]'
                      >
                        <input
                          id="coBorrowerfalse"
                          v-model="data.keys.coBorrower"
                          @click="next()"
                          type="radio"
                          :value="false"
                        />
                        <label for="coBorrowerfalse">Non</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" v-if="step == 18">
                <div class="col-md-6 offset-md-3 ">
                  <div class="row">
                    <div class="col-md-12 mt-3 mb-3 text-center">
                      <div class="title_form_section">
                        Quelle la statut de votre co-emprunteur ?
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.coContract == 'CDI') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="coContractCDI"
                          v-model="data.keys.coContract"
                          @click="next()"
                          name="coContract"
                          type="radio"
                          value="CDI"
                        />
                        <label for="coContractCDI">En CDI</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.coContract == 'CDD') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="coContractCDD"
                          v-model="data.keys.coContract"
                          @click="next()"
                          name="coContract"
                          type="radio"
                          value="CDD"
                        />
                        <label for="coContractCDD">En CDD</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.coContract == 'unemployed') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="coContractunemployed"
                          v-model="data.keys.coContract"
                          @click="next()"
                          name="coContract"
                          type="radio"
                          value="unemployed"
                        />
                        <label for="coContractunemployed">Sans emploi</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.coContract == 'retired') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="coContractretired"
                          v-model="data.keys.coContract"
                          @click="next()"
                          name="coContract"
                          type="radio"
                          value="retired"
                        />
                        <label for="coContractretired">Retraité</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.coContract == 'seasonal') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="coContractseasonal"
                          v-model="data.keys.coContract"
                          @click="next()"
                          name="coContract"
                          type="radio"
                          value="seasonal"
                        />
                        <label for="coContractseasonal">Saisonnier(e)</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.coContract == 'public_sector') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="coContractpublic_sector"
                          v-model="data.keys.coContract"
                          @click="next()"
                          name="coContract"
                          type="radio"
                          value="public_sector"
                        />
                        <label for="coContractpublic_sector"
                          >Fonctionnaire</label
                        >
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.coContract == 'self_employed_worker') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="coContractself_employed_worker"
                          v-model="data.keys.coContract"
                          @click="next()"
                          name="coContract"
                          type="radio"
                          value="self_employed_worker"
                        />
                        <label for="coContractself_employed_worker"
                          >Travailleur indépendant / Chef d'entreprise</label
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" v-if="step == 19">
                <div class="col-md-6 offset-md-3">
                  <div class="row">
                    <div class="col-md-12 mt-3 mb-3 text-center">
                      <div class="title_form_section">
                        Quelle la profession de votre co-emprunteur ?
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.coProfession == 'employee') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="coProfessionemployee"
                          v-model="data.keys.coProfession"
                          value="employee"
                          @click="next()"
                          name="coProfession"
                          type="radio"
                        />
                        <label for="coProfessionemployee">Salarié</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.coProfession == 'retired') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="coProfessionretired"
                          v-model="data.keys.coProfession"
                          value="retired"
                          @click="next()"
                          name="coProfession"
                          type="radio"
                        />
                        <label for="coProfessionretired">Retraité</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.coProfession == 'craftmen') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="coProfessioncraftmen"
                          v-model="data.keys.coProfession"
                          value="craftmen"
                          @click="next()"
                          name="coProfession"
                          type="radio"
                        />
                        <label for="coProfessioncraftmen"
                          >Artisan/indépendant</label
                        >
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.coProfession == 'employee') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="coProfessionemployee"
                          v-model="data.keys.coProfession"
                          value="employee"
                          @click="next()"
                          name="coProfession"
                          type="radio"
                        />
                        <label for="coProfessionemployee"
                          >Chef d'entreprise</label
                        >
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.coProfession == 'liberal_profession') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="coProfessionliberal_profession"
                          v-model="data.keys.coProfession"
                          value="liberal_profession"
                          @click="next()"
                          name="coProfession"
                          type="radio"
                        />
                        <label for="coProfessionliberal_profession"
                          >Profession libérale</label
                        >
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.coProfession == 'student') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="coProfessionstudent"
                          v-model="data.keys.coProfession"
                          value="student"
                          @click="next()"
                          name="coProfession"
                          type="radio"
                        />
                        <label for="coProfessionstudent">Etudiant</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.coProfession == 'unemployed') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="coProfessionunemployed"
                          v-model="data.keys.coProfession"
                          value="unemployed"
                          @click="next()"
                          name="coProfession"
                          type="radio"
                        />
                        <label for="coProfessionunemployed"
                          >Sans profession</label
                        >
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.coProfession == 'unemployed') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="coProfessionunemployed"
                          v-model="data.keys.coProfession"
                          value="unemployed"
                          @click="next()"
                          name="coProfession"
                          type="radio"
                        />
                        <label for="coProfessionunemployed"
                          >Recherche d'emploi</label
                        >
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.coProfession == 'other') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="coProfessionother"
                          v-model="data.keys.coProfession"
                          value="other"
                          @click="next()"
                          name="coProfession"
                          type="radio"
                        />
                        <label for="coProfessionother">Autre</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" v-if="step == 20">
                <div class="col-md-6 offset-md-3">
                  <div class="row">
                    <div class="col-md-12 mt-3 mb-3 text-center">
                      <div class="title_form_section">
                       Quels sont les revenus de votre Co-emprunteur ?
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.coIncome == '800') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="coIncome800"
                          v-model="data.keys.coIncome"
                          @click="next()"
                          name="coIncome"
                          type="radio"
                          value="800"
                        />
                        <label for="coIncome800">Moins de 900€/Mois</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.coIncome == '1000') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="coIncome1000"
                          v-model="data.keys.coIncome"
                          @click="next()"
                          name="coIncome"
                          type="radio"
                          value="1000"
                        />
                        <label for="coIncome1000">De 900€ à 1300€/Mois</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.coIncome == '1400') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="coIncome1400"
                          v-model="data.keys.coIncome"
                          @click="next()"
                          name="coIncome"
                          type="radio"
                          value="1400"
                        />
                        <label for="coIncome1400">De 1300 à 1700€/Mois </label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.coIncome == '1800') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="coIncome1800"
                          v-model="data.keys.coIncome"
                          @click="next()"
                          name="coIncome"
                          type="radio"
                          value="1800"
                        />
                        <label for="coIncome1800">De 1700 à 2100€/Mois</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.coIncome == '2200') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="coIncome2200"
                          v-model="data.keys.coIncome"
                          @click="next()"
                          name="coIncome"
                          type="radio"
                          value="2200"
                        />
                        <label for="coIncome2200">De 2100 à 2800€/Mois</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.coIncome == '2900') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="coIncome2900"
                          v-model="data.keys.coIncome"
                          @click="next()"
                          name="coIncome"
                          type="radio"
                          value="2900"
                        />
                        <label for="coIncome2900">De 2800€ à 4000€/Mois </label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        :class="[(data.keys.coIncome == '4000') ? 'inputGroup radioSelected' : 'inputGroup']"
                      >
                        <input
                          id="coIncome400"
                          v-model="data.keys.coIncome"
                          @click="next()"
                          name="coIncome"
                          type="radio"
                          value="4000"
                        />
                        <label for="coIncome400">Plus de 4000€/Mois</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" v-if="step == 21">
                <div class="col-md-12 title_form_section mt-3 mb-3">Merci</div>
                <div class="col-md-12 title_form_section p-4">
                  <svg
                    width="150"
                    height="150"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 507.2 507.2"
                  >
                    <circle cx="253.6" cy="253.6" r="253.6" fill="#32ba7c" />
                    <path
                      d="M188.8 368l130.4 130.4c108-28.8 188-127.2 188-244.8v-7.2L404.8 152l-216 216z"
                      fill="#0aa06e"
                    />
                    <g fill="#fff">
                      <path
                        d="M260 310.4c11.2 11.2 11.2 30.4 0 41.6l-23.2 23.2c-11.2 11.2-30.4 11.2-41.6 0L93.6 272.8c-11.2-11.2-11.2-30.4 0-41.6l23.2-23.2c11.2-11.2 30.4-11.2 41.6 0L260 310.4z"
                      />
                      <path
                        d="M348.8 133.6c11.2-11.2 30.4-11.2 41.6 0l23.2 23.2c11.2 11.2 11.2 30.4 0 41.6l-176 175.2c-11.2 11.2-30.4 11.2-41.6 0l-23.2-23.2c-11.2-11.2-11.2-30.4 0-41.6l176-175.2z"
                      />
                    </g>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
    <div :class="{ hideIt: !seen }">
         <section class="footer">
      <div class="footer-content container">
        Rachat de Crédit 2022 Mentions légales <br />
    La diminution du montant des mensualités peut entrainer l'allongement de la durée de remboursement et la majoration du coût total du crédit. Aucun versement de quelque nature que ce soit, ne peut être exigé d’un particulier, avant l’obtention d’un ou de plusieurs prêts d’argent. selon l' articles L312-1 du Code de la Consommation, vous disposez d’un délai de rétractation de 14 jours à compter de l’acceptation du crédit. Pour un financement relevant des articles L313-1 et suivants du Code de la Consommation, vous disposez d’un délai de réflexion de 10 jours à compter de la réception du contrat de crédit. Ce service est proposé par la société <a href="https://leads.fr" style="color: white;"> Leads.fr </a> inscrite au Registre des intermédiaires en assurance, banque et finance (ORIAS) sous le n°d’immatriculation 20005729 en qualité d’intermédiaire en opérations de banque et en service de paiement (IOBSP) dans la catégorie mandataire d’intermédiaire. Les données recueillies sont destinées à <a href="https://leads.fr" style="color: white;"> Leads.fr </a> et à ses partenaires dans le cadre de l’étude de votre demande. Vous disposez d’un droit d’accès, de rectification, d’opposition et de portabilité, dans le respect de la RGPD. Pour l’exercer, remplissez <a href="https://rachat-credit-meilleures-conditions.fr/contactez-nous/" style="color: white;"> notre formulaire de contact</a>. Pour plus d’information concernant le traitement des données et le fonctionnement des services, veuillez consulter notre <a href="https://leads.fr/cgu.pdf" style="color: white;"> politique de confidentialité </a>. Un crédit vous engage et doit être remboursé. Vérifiez vos capacités de remboursement avant de vous engager. ‍ Ce site n'est pas avalisé par l'état Français et n'émane pas de lui. Cette page est un contenu sponsorisé édité par Localiweb,7 rue françois Coppée , 92240 Malakoff, immatriculée au registre du commerce de Nanterre sous le numéro 819925983.
      </div>
      <div class="waves-footer" :class="[(step == 8) ? 'section_two-y' : '']">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
          <path
            fill="#0648b3"
            fill-opacity="1"
            d="M0,224L80,234.7C160,245,320,267,480,256C640,245,800,203,960,197.3C1120,192,1280,224,1360,240L1440,256L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"
          ></path>
        </svg>
      </div>
      <hr />
      <p class="text-center text-white">Tous droits réservés &copy; 2022</p>
    </section>
    </div>
  </div>
</template>

<script>

let domain = "https://rachat-credit-meilleures-conditions.fr/webrac";
import axios from 'axios';
import Textes from './textes.json'
export default {
  name: 'App',
  data(){
    return{
      textes : Textes,
      params   : '',
      confirm_credit_status:false,
      togglealert:false,
      sectionone:false,
      sectiontwo:false,
      sectionone_1:false,
      sectiontwo_2:false, 
      consumptionCreditNumbertoggle:true,
      consumptionCapitalone : false,
      monthlyConsumptionRepaymentAmountchangetwo:false,
      consumptionCapitalone_1 : false,
      monthlyConsumptionRepaymentAmountchangetwo_2:false,
      idp :"",
      seen:true,
      url:"",
      dates:[],
      step     : 1,
      progress :12.5,
       show: true,
       showbutton:false,
      cities   :{},
      threenexterror:"",
      fivenexterror :"",
      age           :null, 
      fbclid        : null, 
      data     :{
        "firstName": "",
        "lastName" : "",
        "phone"    : "",
        "email"    : "",
        "zip"      : "",
        "sitekey"  : "Localiweb_tab",
        "area"     : "RAC",
        "link"     : "",  
        "keys":    {

               "contractYear": '2017',
               "bankOfFrance": false,
               "charges"     : '',
               "consumptionCapital":"30000",
                "city"       : '',
                "civility"   : '',
                "contract"   : '',
                "consumptionCreditNumber": '',
                "monthlyConsumptionRepaymentAmount": '1500',
                "childNumber": '0',
                "profession": '',
                "salary": '',
                "familySituation": 'single',
                "address": '',
                "treasure": '',
                "realEstateValue": '',
                "isOwner":"",
                "rent"   :'',
                "mortgageLoanNumber": '',
                "realEstateCapital" :'250000',
                "monthlyRealEstate" :'1500',
                "coBorrower":  false,
                "coIncome": '',
                "coContract": '',
                "coProfession": '',
                "DOB": '',
                "seniority": '3',
                "ip": ''

             }
      },
      facebook:{
        "email": "",
        "phone": "",
        "area" : "RAC",
        "event": "",
      },
      errors:{
         'seniority': '',
          "firstname": "",
          "lastname" : "",
          "phone"    : "",
          "email"    : "",
          "zip"      : "",
          "DOB"      : "",
          "civility" : "",
          "address"  : "",
          "treasure" : "",
          "realEstateValue":"",
          "contractYear" :"",
          "city"         :"",
          "monthlyConsumptionRepaymentAmount":"0",
          "rent":"",


      }
    }
  },
  methods:{
   confirm_credit(){
              this.data.keys.consumptionCapital = "0";
               this.data.keys.monthlyConsumptionRepaymentAmount = "0";
               //this.progress += 9.09;
               this.step = 6; 
    },
    threenext(){
         if(this.data.keys.realEstateCapital == "0" || this.data.keys.monthlyRealEstate == "0"){
            this.threenexterror = "Veuillez choisir les valeurs correctes SVP :";
              if(this.data.keys.realEstateCapital == "0"){
                     this.sectionone_1 = true;
              }else{
                this.sectionone_1 = false;
                  this.sectionone = true;
              }

            if(this.data.keys.monthlyRealEstate == "0"){
               this.sectiontwo_2  = true;
             }else{
                this.sectiontwo_2  = false;
                this.sectiontwo = true;
             }
            return;
         }

         this.threenexterror = "";
         this.sectionone_1 = false;
         this.sectiontwo_2  = false;
         this.sectionone = true;
         this.sectiontwo = true;
         this.next();
    },
    fivenext(){
        if(this.data.keys.consumptionCapital == "0" || this.data.keys.monthlyConsumptionRepaymentAmount == "0"){
            this.fivenexterror = "Veuillez choisir les valeurs correctes SVP :";
              if(this.data.keys.consumptionCapital == "0"){
                     this.consumptionCapitalone_1 = true;
                     this.consumptionCapitalone = false;
              }else{
                this.consumptionCapitalone_1 = false;
                  this.consumptionCapitalone = true;
              }

            if(this.data.keys.monthlyConsumptionRepaymentAmount == "0"){
               this.monthlyConsumptionRepaymentAmountchangetwo_2  = true;
               this.monthlyConsumptionRepaymentAmountchangetwo = false;
             }else{
                this.monthlyConsumptionRepaymentAmountchangetwo_2  = false;
                this.monthlyConsumptionRepaymentAmountchangetwo = true;
             }
            return;
         }

        this.fivenexterror = "";
        this.consumptionCapitalone_1 = false; 
        this.monthlyConsumptionRepaymentAmountchangetwo_2 =  false; 
        this.consumptionCapitalone = true;
        this.monthlyConsumptionRepaymentAmountchangetwo = true;
        this.next();
    },
    realEstateCapitalchange(){
         this.sectionone = true;
    },
    monthlyRealEstatechange(){
         this.sectiontwo = true;

    },
    consumptionCapitalchange(){
       this.consumptionCapitalone = true;
    },
    monthlyConsumptionRepaymentAmountchange(){
        this.monthlyConsumptionRepaymentAmountchangetwo = true;
    },
    scrollToTop() {
                window.scrollTo(0,0);
     },
    dealy(){
          var self = this;
          setTimeout(function(){
             self.progress += 12.5;
               self.step = 10;
          },2000);
    },numberWithSpaces() {
      if(this.data.phone.length > 0){
          var res = this.data.phone.replace(/\s/g,"");
          console.log("res=> "+this.data.phone)
          this.data.phone = res.split(/(\d{2})/).join(' ').trim().replace(/\s\s/g," ");
      }


      console.log(this.data.phone)
    },
    next(){

        var self = this;

            this.show = !this.show;

               self.seen = false;
               console.log("step : "+self.step);
         
          setTimeout(function(){
             self.show = !self.show;
             
            if(self.step == 1 && self.data.keys.isOwner == 'false'){
                 //self.show = true;
                 
                 self.progress += 25;
                  self.data.keys.realEstateCapital = 0;
                  self.data.keys.monthlyRealEstate = 0;
                   self.step = 4;
                  
                 return;
            }

            if(self.step == 2 && self.data.keys.isOwner == 'false'){
                 self.progress += 25;

                   self.step = 4;
                   //self.show = !this.show;
                 return;
            }

            if(self.step == 4 && self.data.keys.consumptionCreditNumber == '0'){
             
               self.confirm_credit_status = true;
               // self.progress = 60;
               // self.step++;
               // self.show = !this.show;
                 return;
            }



            if(self.step == 5 && self.data.keys.consumptionCapital  && self.data.keys.monthlyConsumptionRepaymentAmount){
                      self.progress = 60;

              }

            if(self.data.keys.contract !== '' && self.step == 7){

                        if(self.data.keys.contract == 'unemployed'){
                            self.data.keys.profession = 'unemployed';
                        }
                      if(self.data.keys.contract == 'CDI' || self.data.keys.contract == 'CDD' || self.data.keys.contract == 'public_sector' || self.data.keys.contract == 'seasonal'){
                            self.data.keys.profession = 'employee';
                        }
                        if(self.data.keys.contract == 'retired'){
                            self.data.keys.profession = 'retired';
                        }
                          if(self.data.keys.contract == 'self_employed_worker'){
                            self.data.keys.profession = 'entrepreneur';
                        }
              }

            if (self.step > 8) {
                 if(self.step == 10){
                     self.step = 11;
                     return;
                  } 

               if(self.step == 13 && self.data.keys.isOwner == 'true' && self.data.keys.realEstateValue == ""){
                 self.errors.realEstateValue = "Ce champ est obligatoire.";
                  return;
               }


             if(self.step == 13 && self.data.keys.isOwner == 'false' && self.data.keys.rent == ""){
                 self.errors.rent = "Ce champ est obligatoire.";
                  return;
               }
              
               if(self.step == 11){
                      self.data.keys.profession = "";
                      self.step = 12;
                      return;
               }

               if(self.data.keys.profession == "" && self.step ==  12){
                     self.step = 12;
                          return;
               } 
          

               axios.post(domain+'/web.php',{
                  'data':self.data,
                  'url' : '' 
                 })
                  .then(res=>{
                    console.log(res.data)
                    if(res.data.status == 200){
                          //self.show = !self.show;
                       if(self.data.keys.coBorrower == false && self.step ==  17){
                             window.location.replace("https://forms.leads.fr/rac.thankyou");
                            //self.step = 21;

                        }else{
                               

                              

                              if(self.step == 12){
                                 self.step = 13;
                                  return;
                              }

                              if(self.step == 13 && self.data.keys.isOwner == 'true' && self.data.keys.realEstateValue == ''){
                                   self.step = 13;
                                  return;
                              }

                              //if(step == 13 && self.data.keys.isOwner == 'true' && self.data.keys.realEstateValue != ''){
                                  
                                
                              //}

                              if(self.step == 13 && self.data.keys.isOwner == 'true' && self.data.keys.realEstateValue != ''){
                                   self.data.keys.realEstateValue  = parseInt(self.data.keys.realEstateValue);
                                   self.step = 14;
                                  return;
                              }



                              if(self.step == 13 && self.data.keys.isOwner == 'false' && self.data.keys.rent == ''){
                                   self.step = 13;
                                  return;
                              }

                              if(self.step == 13 && self.data.keys.isOwner == 'false' && self.data.keys.rent != ''){
                                   self.step = 14;
                                  return;
                              }
                              

                             if(self.data.keys.familySituation == "single" && self.step == 14){
                                 self.step++;
                                 self.step++;
                                 //self.show = !this.show;
                                 return;
                              }

                             if(self.data.keys.familySituation != "single" && self.step == 14){
                                 self.step = 15;
                                 return;
                              }
                              
                              if(self.step == 15){
                                 self.step = 16;
                                 return;
                              }

                              if(self.step == 16){
                                 self.step = 17;
                                 self.data.keys.coBorrower ="";
                                 return;
                              }

                              if(self.data.keys.coBorrower == true && self.step == 17){
                                  self.step = 18;
                                 return;
                              }

                             if(self.step == 18 && self.data.keys.coContract == "" && self.data.keys.coBorrower == true){
                                 self.step = 18;
                                 return;
                              }

                             if(self.step == 18 && self.data.keys.coContract != "" && self.data.keys.coBorrower == true){
                                 self.step = 19;
                                 return;
                              }

                              if(self.step == 19 && self.data.keys.coProfession == "" && self.data.keys.coBorrower == true){
                                 self.step = 19;
                                 return;
                              }

                             if(self.step == 19 && self.data.keys.coProfession != "" && self.data.keys.coBorrower == true){
                                 self.step = 20;
                                 return;
                              }

                              if(self.step == 20 && self.data.keys.coIncome == "" && self.data.keys.coBorrower == true){
                                 self.step = 20;
                                 return;
                              }

                              if(self.step == 20 && self.data.keys.coIncome != "" && self.data.keys.coBorrower == true){
                                  window.location.replace("https://forms.leads.fr/rac.thankyou");
                                 return;
                              }


                        }

                     }

                  })
                  .catch(err=>console.log(err))




            }
            else{
                
               if(self.step == 1 && self.data.keys.isOwner == 'true'){
                 self.progress += 11.11;
                    self.step = 2;
                    return;
               }

               if(self.step == 2 && self.data.keys.mortgageLoanNumber == '1'){
                 self.progress += 11.11;
                    self.step = 3;
                    return;
               }

               if(self.step == 2 && self.data.keys.mortgageLoanNumber == '0'){
                 self.data.keys.realEstateCapital = 0;
                 self.data.keys.monthlyRealEstate = 0;
                 self.progress += 11.11;
                    self.step = 4;
                    return;
               }


               if(self.step == 3 && self.sectionone == true){
                 self.progress += 11.11;
                    self.step = 4; 
                    return;
               }

       
               if(self.step == 4 && self.data.keys.consumptionCreditNumber == 0){
                  self.step = 4;
                  return;
               }

               if(self.step == 4 && self.data.keys.consumptionCreditNumber != 0){
                 self.progress += 11.11;
                  self.step = 5;
                  return;
               }

               if(self.step == 5 && self.monthlyConsumptionRepaymentAmountchangetwo != true){
                 self.progress += 11.11;
                  self.step = 5;
                  return;
               }

              if(self.step == 5 && self.monthlyConsumptionRepaymentAmountchangetwo == true && self.consumptionCapitalone == true){
                 self.progress += 11.11;
                  self.step = 6;
                  return;
               }

               if(self.step == 6 && self.data.keys.salary == ''){
                    self.step = 6;
                    return;
                }

               if(self.step == 6 && self.data.keys.salary != ''){
                 self.progress += 11.11;
                    self.step = 7;
                    return;
                }

                if(self.step == 7 && self.data.keys.contract == ''){
                    self.step = 7;
                    return;
                }

                if(self.step == 7 && self.data.keys.contract != ''){
                
                    self.progress += 11.11;
                    self.step = 8;
                    //self.dealy();
                    return;
                }

                if(self.step == 8 && self.data.keys.treasure == ''){
                    self.step = 8;
                    return;
                }

                if(self.step == 8 && self.data.keys.treasure != ''){
                    self.progress += 11.11;
                    self.step = 9;
                    self.dealy();
                    return;
                }

    

           }

          },500);


    },
    prev(){
       this.togglealert = false;
      this.data.keys.consumptionCreditNumber = "";
    },
    rangdate(){
       var date = new Date();
         var year = date.getFullYear();
       for(var i = 1950;i < year+1 ;i++){
         this.dates.push(i);
       }
    },
     Random(min, max) {
      return Math.floor(min + Math.random()*(max + 1 - min))
    },
    onlyNumber($event) {
       let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
       if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {

          $event.preventDefault();
       }
    },
   isEmpty(champ) {
      return (champ == '') ? true : false;
    },
    EmailValidate(email){
              const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
               return re.test(email);
    },
   PhoneValidate(phone){
       phone = phone.replace(/\s/g, '');
       const phoneExp = /^((\+)33|0|0033)[1-9](\d{2}){4}$/g;
        return phoneExp.test(phone);
    },
    save(){

            if(this.isEmpty(this.data.keys.civility)){
              this.errors.civility = "Ce champ est obligatoire.";
              this.scrollToTop();
              return;
            }
              this.errors.civility = '';
             if(this.isEmpty(this.data.firstName)){
              this.errors.firstname = "Ce champ est obligatoire.";
               this.scrollToTop();
              return;
            }
              this.errors.firstname = '';

            if(this.isEmpty(this.data.lastName)){
              this.errors.lastname = "Ce champ est obligatoire.";
               this.scrollToTop();
              return;
            }
              this.errors.lastname = '';

            if(this.isEmpty(this.data.keys.DOB)){
              this.errors.DOB = "Ce champ est obligatoire.";
               this.scrollToTop();
              return;
            }

             const redob = /^\d{4}$/;
            
            if(!redob.test(this.data.keys.DOB)){
                this.errors.DOB = "veuillez saisir la date de naissance correcte";
                 this.scrollToTop();
                 return;
             }
             


           var date = new Date();
            var year = date.getFullYear();
             if((parseInt(this.data.keys.DOB) < 1900)){

                this.errors.DOB = "Vous devez saisir un nombre compris entre 1900 et "+year;
                 this.scrollToTop();
                 return;
             }


            if(parseInt(this.data.keys.DOB) > parseInt(year)){

                this.errors.DOB = "Vous devez saisir un nombre compris entre 1900 et "+year;
                 this.scrollToTop();
                 return;
             }
              this.errors.DOB = '';

             var toInt = parseInt(this.data.keys.DOB);
            
             this.age = parseInt(year) - toInt;

            if(this.isEmpty(this.data.keys.address)){
              this.errors.address = "Ce champ est obligatoire.";
                 this.scrollToTop();
              return;

            }
             this.errors.address = '';
            if(this.isEmpty(this.data.zip)){
              this.errors.zip = "Ce champ est obligatoire.";
               this.scrollToTop();
              return;
            }

            if(this.cities === 0){
              //this.errors.zip = "Code postal incorrect";
              //return;
              this.data.keys.city = "Non fourni !";
            }
              this.errors.zip = '';



            if(this.isEmpty(this.data.keys.city)){
              this.errors.city = "Ce champ est obligatoire.";
              return;
            }
             this.errors.city = '';


           if(this.isEmpty(this.data.keys.contractYear)){
              this.errors.contractYear = "Ce champ est obligatoire.";
              return;
            }
              this.errors.contractYear = '';


          if(this.isEmpty(this.data.email)){
              this.errors.email = "Ce champ est obligatoire.";
               //this.scrollToTop();
              return;
            }
            if(!this.EmailValidate(this.data.email)){
                this.errors.email = "email non valide";
                // this.scrollToTop();
                 return;
             }
              this.errors.email = '';
            if(this.isEmpty(this.data.phone)){
              this.errors.phone = "Ce champ est obligatoire.";
               this.scrollToTop();
              return;
            }
            if(!this.PhoneValidate(this.data.phone)){
                 this.errors.phone = "teléphone non valide";
                   return;
             }
              this.errors.phone = '';

 
           /* end salary */

          if(this.data.keys.isOwner == "true"){
               if(this.data.keys.mortgageLoanNumber == 1){
                 //this.data.keys.realEstateValue = this.data.keys.realEstateCapital * 1.30;
                 this.data.keys.realEstateValue = '325000';
               }else{
                 this.data.keys.realEstateValue = "250000";
               }
          }
      

         var dn = this.data.keys.DOB+'-01-01';

         this.data.keys.DOB = dn.replace(/\s+/g, '');


        
            this.eventpixel();
         
      
         axios.post(domain+'/web.php',{
           'data':this.data,
            "url":this.params

            })
              .then(res=>{
                console.log(res.data)
                  this.url = "https://rachat-credit-meilleures-conditions.fr/confirmation/";
                  this.progress = 100;
                  this.step = 11;

              })
              .catch(err=>console.log(err))
             
            

    },
     getIp(){
      axios.get('https://jsonip.com',{ mode: 'cors' }).then(res=>{
           console.log(res.data.ip);
           this.data.keys.ip = res.data.ip;
      }).catch(err=>{
            console.log(err);
      });
    },
    fetchzipcode(){
      axios.get(domain+'/zipcode.php?code='+this.data.zip,{
            responseType: "json",
         })
           .then(res=>{
                 if(res.data == 0){
                   this.cities = res.data;
                 }else{
                    this.errors.zip = "";
                   this.cities = res.data;
                   //console.log(this.cities.length);
                   if(this.cities.length >= 1){
                    this.data.keys.city = this.cities[0].name;
                   }else{
                     this.data.keys.city = "Non fourni !";
                   }
                 }


           })
           .catch(err=>console.log(err));
    },
   eventpixel(){
      var crd_conso_treso = parseInt(this.data.keys.consumptionCapital) + parseInt(this.data.keys.treasure);

      this.facebook.phone = this.data.phone;
      this.facebook.email = this.data.email;
      
       const pro = ['employee','retired','liberal_profession','entrepreneur']; 
    
     if(crd_conso_treso >= 15000 && parseInt(this.data.keys.consumptionCreditNumber) >= 2 &&  pro.includes(this.data.keys.profession) && this.data.keys.bankOfFrance == "false" && parseInt(this.data.keys.salary) >= 1500 && parseInt(this.age) > 24 && parseInt(this.age) < 69){
        if(this.fbclid != null){
           window.fbq('track', 'Lead', {}, { eventID: 'Lead'+this.fbclid });
          this.facebook.event = 'Lead'; 
              axios.post(`${domain}/trackv.php?fbclid=${this.fbclid}&event_id=${this.facebook.event}${this.fbclid}`,this.facebook).then(res=>{
                 console.log(res)
              }).catch(err=>{
                  console.log(err)
              })
        }else{
          window.fbq('track', 'Lead');
        }

      } 

      if( parseInt(this.data.keys.consumptionCreditNumber) >= 1 ){
         if(this.fbclid != null){

          window.fbq('track', 'CompleteRegistration', {}, { eventID: 'CompleteRegistration'+this.fbclid });
         this.facebook.event = 'CompleteRegistration';
            axios.post(`${domain}/trackv.php?fbclid=${this.fbclid}&event_id=${this.facebook.event}${this.fbclid}`,this.facebook);
         
          }else{
              window.fbq('track', 'CompleteRegistration');
          }
        }
        
         
   
         if(this.fbclid != null){
            window.fbq('track', 'ViewContent', {}, { eventID: 'ViewContent'+this.fbclid });
           this.facebook.event = 'ViewContent';
           axios.post(`${domain}/trackv.php?fbclid=${this.fbclid}&event_id=${this.facebook.event}${this.fbclid}`,this.facebook).then(res=>{
               console.log(res)
            }).catch(err=>{
                console.log(err)
           })
          }else{
            window.fbq('track', 'ViewContent');
          }
    }

  },
  created(){

    var route =  window.location.search;
    this.params = (route) ? route : "";

    var url_string =  window.location.href;
    this.data.link =  url_string;
    var url = new URL(url_string);

    var sitekey = url.searchParams.get("sitekey");
    var fbclid = url.searchParams.get("fbclid");
     if(fbclid != null){
        this.fbclid = fbclid;
     }

    if(sitekey != null){
       this.data.sitekey = sitekey;
    }
    axios.get('/textes.json',{
            responseType: "json",
         })
           .then(res=>{
                this.textes = res.data;
                console.log(res.data);

           })
           .catch(err=>console.log(err));
    this.getIp();

  }
}

</script>

<style scoped>
.btn-x {
  background-color: #f1f1f1;
  border-color: #f1f1f1;
  font-size: 12px;
  color: #222 !important;
}

.fade {
  transition: all 0.3s ease;
  opacity: 0.2;
}
</style>